import { Component,EventEmitter,Input, Output } from '@angular/core';

@Component({
  selector: 'app-photos-section',
  templateUrl: './photos-section.component.html',
  styleUrls: ['./photos-section.component.scss']
})
export class PhotosSectionComponent {
  @Input() imageUrl: string;
  @Input() showButtons: boolean = true;
  @Input() index: number;
  @Output() delete = new EventEmitter<number>();
  @Output() edit = new EventEmitter<any>();

  onDelete(): void {
    this.delete.emit(this.index);
  }

  editPhoto() {
    this.edit.emit();
  }

  //TODO:once get all products remove it
  isImageUrl(url: string): boolean {
    return url.startsWith('http') || url.startsWith('/') || url.startsWith('./') || url.startsWith('../');
  }
}
